import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useIsAuth0Configured } from '../auth/auth0_configuration';
import { AdminResultsPage } from './admin_results_page';

const AuthenticatedAdminResultsPage = withAuthenticationRequired(AdminResultsPage, {
  returnTo: () => '/admin/results',
  onRedirecting: () => (
    <div
      role="status"
      aria-label="Redirecting to sign in"
      className="app-gradient flex min-h-[calc(100dvh-3.5rem)] items-center justify-center px-6"
    >
      <p className="surface-card p-6 font-black text-qs-navy">Redirecting to sign in...</p>
    </div>
  ),
});

export function AdminResultsRoute() {
  const isAuth0Configured = useIsAuth0Configured();

  if (!isAuth0Configured) {
    return (
      <div className="app-gradient min-h-[calc(100dvh-3.5rem)] py-12">
        <section className="mx-auto w-full max-w-2xl px-6">
          <div role="alert" className="surface-card p-6 sm:p-8">
            <h1 className="text-2xl font-black text-qs-navy">Authentication is not configured</h1>
            <p className="mt-3 leading-7 text-aws-slate">
              Configure the Auth0 frontend environment variables, then restart the frontend to manage results.
            </p>
          </div>
        </section>
      </div>
    );
  }

  return <AuthenticatedAdminResultsPage />;
}
